"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const menuContext_1 = require("./menu/menuContext");
const MenuItem = ({ children, onClick, icon, disabled = false, className, ...rest }) => {
    const { scrollable } = (0, menuContext_1.useDropdownMenu)();
    return ((0, jsx_runtime_1.jsxs)("hot-dropdown-menu-item", { onClick: onClick, class: (0, classnames_1.default)(className, {
            'hot-dropdown-menu__item--disabled': disabled
        }), "data-test": "dropdown-menu-item", ...(!scrollable && { slot: 'menu' }), ...rest, children: [icon && (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon, className: "_mr-2" }), children] }));
};
exports.default = MenuItem;
